<template>
    <div>
        <NavBarLight></NavBarLight>
        <span class="full-body">
            <br>
            <span v-if="this.$route.params.slug === 'react-native'" class="heading">React Native Challenge</span>
            <span v-else-if="this.$route.params.slug === 'android'" class="heading">Android Challenge</span><br><br><br>
            <div class="quiz-point text-left"><span><i class="fa fa-check-square-o"></i>Select the most correct answer for every question</span></div><br>
            <div class="quiz-point text-left"><span><i class="fa fa-check-square-o"></i>You have a time limit of <b>15 minutes</b></span></div><br>    
            <div class="quiz-point text-left"><span><i class="fa fa-check-square-o"></i>You can only attempt the quiz <b>once</b></span></div><br>
            <div class="quiz-point text-left"><span><i class="fa fa-check-square-o"></i>There is no negative marking</span></div><br>
            <div class="quiz-point text-left"><span><i class="fa fa-check-square-o"></i>Please take the quiz on a <b>laptop</b> or <b>desktop</b></span></div><br>
            <div class="quiz-point text-left"><span><i class="fa fa-check-square-o"></i>DO NOT PRESS THE BACK BUTTON</span></div><br>
            <br>
            <a class="btn btn-success" id="submit-work" v-on:click="startQuiz">
                START QUIZ
            </a>
            <br>

        </span>
    </div>
</template>


<script>
import NavBarLight from '../components/NavBarLight.vue'
import firebase from '../services/firebase'

export default {
    name: 'Quiz',
    components: {
        NavBarLight
    },
    methods: {
        startQuiz: function() {
            mixpanel.track("quiz started", {
                "user_id": firebase.auth().currentUser.uid,
                "quiz_name": this.$route.params.slug,
                "email": firebase.auth().currentUser.email
            });
            this.$router.push(this.$route.path + '/start');
        }
    }
}
</script>


<style scoped>
    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

    .full-body {
        margin-top: 80px;
        margin-bottom: 30px;
        padding-top:10px; 
        padding-bottom:30px; 
        width:70%;
        border:none;
        border-radius: 10px;
        box-shadow: 4px 2px 4px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
        font-family: Avenir;
        cursor:pointer;
        background-color:#fff;
        display:inline-block;
        color: #333;
    }

    .heading {
        padding-top: 0px;
        font-size: 1.55rem;
    }

    .quiz-point {
        margin-left: 25%;
        margin-right: 20%;
    }

    #submit-work {
        margin-top:1%;
        margin-bottom:1%;
		padding-top:9px;
		padding-bottom:9px;
		padding-left:6%;
		padding-right:6%;
        justify-content: center;
        align-self: center;
        margin:auto;
		width:30%;
		background-color:#f25792;
		border-color:#f25792;
		color:#fff;
        font-size:0.96rem;
        cursor: pointer;
    }

    .fa {
        margin-right: 10px;
        font-style: Helvetica;
    }


</style>
